import React from "react"

const NotAuthorizedPage = () => {
    return <>
        {"NotAuthorized"}
    </>
}

export default NotAuthorizedPage;